import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { AdminComponent } from './layouts/admin/admin.component';
import { TitleComponent } from './layouts/admin/title/title.component';
import { BreadcrumbsComponent } from './layouts/admin/breadcrumbs/breadcrumbs.component';
import { AuthComponent } from './layouts/auth/auth.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { AuthService } from './services/auth.service';
import { CustomFormsModule } from 'ng2-validation';
import { AuthGuard } from './shared/guards/auth.guard';
import { TokenInterceptor } from './auth/token.interceptor';
import { UserService } from './services/user.service';
import { UsersModule } from './components/users/users.module';
import { ClientsModule } from './components/clients/clients.module';
import { ClientService } from './services/client.service';
import { CampaignService } from './services/campaign.service';
import { CampaignDetailModule } from './components/detail/detail.module';
import { ProfileModule } from './components/profile/profile.module';
import { FormService } from './services/form.service';
import { FormsModule } from './components/forms/forms.module';
import { LeadsService } from './services/leads.service';
import { Globals } from './global';
import { CampaignsComponent } from './components/campaigns/campaigns.component';
import { NotificationService } from './services/notification.service';
import { IntegrationService } from './services/integration.service';
import { IdWatchService } from './services/watch.service';
import { IntegrationsComponent } from './components/integrations/integrations.component';
import { FbIntegationsComponent } from './components/integrations/fb-integations/fb-integations.component';
import { PippedriveIntegrationsComponent } from './components/integrations/pippedrive-integrations/pippedrive-integrations.component';
import { AddPippedriveIntegrationsComponent } from './components/integrations/pippedrive-integrations/add-pippedrive-integrations/add-pippedrive-integrations.component';
import { SoundNotificaionsService } from './services/sound-notificaions.service';


@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    TitleComponent,
    BreadcrumbsComponent,
    AuthComponent,
    CampaignsComponent,
    IntegrationsComponent,
    FbIntegationsComponent,
    PippedriveIntegrationsComponent,
    AddPippedriveIntegrationsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    CustomFormsModule,
    UsersModule,
    ClientsModule,
    CampaignDetailModule,
    ProfileModule,
    FormsModule
  ],
  exports: [SharedModule],
  providers: [
    Globals,
    AuthService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    UserService,
    ClientService,
    CampaignService,
    FormService,
    LeadsService,
    NotificationService,
    IntegrationService,
    IdWatchService,
    SoundNotificaionsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts